<button
  data-cy="fieldOptionsMenuButton"
  class="hover:bg-m200 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
  #t1="tippy"
  [tp]="templateFieldOptions"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  className="my-menu"
  [tpOffset]="[0, 5]"
  (click)="clickMenu($event)"
>
  <m-dots-vertical-icon></m-dots-vertical-icon>
</button>

<ng-template #templateFieldOptions>
  <div class="border-s4 bg-m0 flex w-48 flex-col rounded-md border-2 shadow-xl">
    <button
      data-cy="fieldOptionsGoToFileLineButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); goToFileLine($event)"
      >Go to File Line</button
    >

    <!-- <div
      class="text-s400 flex w-full cursor-default px-4 py-2 text-base text-base focus:outline-none"
      (click)="$event.stopImmediatePropagation()"
      >Result: {{ node.data.fieldResult | result }}</div
    > -->
  </div>
</ng-template>
